// fleet-generated: do not edit by hand
//
// Rendered from    : infra/fleet/artifacts/ui-core/tooltip.tmpl.tsx
// Parameters       : infra/fleet/registry/repos.ts  (entry "bible-strong-offline-app")
// Destination      : packages/fleet/ui/src/tooltip.tsx
//
// TO CHANGE THIS FILE, edit the template or the registry entry in infra and
// re-render. Editing it here is reverted by the next render, and the guard
// in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo bible-strong-offline-app
//     node fleet/fleet.ts check --repo bible-strong-offline-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import { Tooltip as TooltipPrimitive } from "@kobalte/core";
import { type JSX, splitProps } from "solid-js";
import { cn } from "@bso/shared";

export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;

export function TooltipContent(
  props: TooltipPrimitive.TooltipContentProps & { class?: string; children?: JSX.Element },
) {
  const [local, others] = splitProps(props, ["class", "children"]);
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        class={cn(
          "z-50 overflow-hidden rounded-md border border-border bg-popover px-3 py-1.5 text-xs text-popover-foreground shadow-md outline-none animate-in fade-in zoom-in-95 duration-150 origin-[var(--kb-tooltip-content-transform-origin)]",
          local.class,
        )}
        {...others}
      >
        {local.children}
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  );
}
